import common from './common.json';
import contractor from './contractor.json';
import dashboard from './dashboard.json';
import validation from './validation.json';
import errors from './errors.json';
import auth from './auth.json';
import home from './home.json';
import progress from './progress.json';
import project from './project.json';
import settings from './settings.json';
import sidebar from './sidebar.json';
import supervisor from './supervisor.json';

export default {
  common,
  contractor,
  dashboard,
  validation,
  errors,
  auth,
  home,
  progress,
  project,
  settings,
  sidebar,
  supervisor,
};
